export enum StocksSortByOptions {
  AMOUNT_USD = 'amountUSD',
  WEIGHT = 'weight',
  LAST_PRICE = 'sharePriceOriginalCurrency',
  UNREALIZED_PL = 'unrealizedPL',
  UNREALIZED_PL_PERCENT = 'unrealizedPLPercent',
  UNREALIZED_DAY_PL = 'unrealizedDayPL',
  UNREALIZED_DAY_PL_PERCENT = 'unrealizedDayPLPercent',
  RETURN_1D = 'return1D',
  AMOUNT_OF_SHARES = 'amountOfShares',
}

export enum PortfoliosSortByOptions {
  AMOUNT = 'amount',
  UNREALIZED_PL = 'unrealizedPL',
  UNREALIZED_PL_PERCENT = 'unrealizedPLPercent',
  UNREALIZED_DAY_PL = 'unrealizedDayPL',
  UNREALIZED_DAY_PL_PERCENT = 'unrealizedDayPLPercent',
  UNREALIZED_12M_PL_PERCENT = 'unrealized12MPLPercent',
  UNREALIZED_12M_PL = 'unrealized12MPL',
  UNREALIZED_1M_PL_PERCENT = 'unrealized1MPLPercent',
  UNREALIZED_1M_PL = 'unrealized1MPL',
}
